import { http } from '@/utils/http';
import qs from 'qs';

const baseUrl = '/vote/2020project/2020clapatwill/controller.php';

// 获取登录信息
const getUserInfo = () => {
  return http.post('/vote/public/controller.php?enews=user-info');
};

// 提交报名
interface ISaveData {
  name: string;
  title: any;
  introduction: any;
  cover: any;
  phone: number;
  userid?: any;
  id?: any;
}
const saveData = (data: ISaveData) => {
  return http.post(`${baseUrl}?enews=save`, qs.stringify(data));
};

const getlist = (page: any, search?: any) => {
  return http.get(
    `${baseUrl}?enews=vote-list&page=` + page + `&search=` + search,
  );
};

const detail = (id: any) => {
  return http.get(`${baseUrl}?enews=detail&id=` + id);
};

const detailUser = () => {
  return http.get(`${baseUrl}?enews=detail-user`);
};

export { getUserInfo, saveData, getlist, detail, detailUser };
